import SupplierList from './List';
import { SupplierCreate, SupplierEdit } from './Form';

export default {
  list: SupplierList,
  create: SupplierCreate,
  edit: SupplierEdit,
};
